/*why-this-error-occurred*/
/*recursion-in-scripts-and-tasks*/
/*package-manager-workspace-misconfiguration*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "递归 `turbo` 调用",
  "description": "了解更多关于 Turborepo 中递归脚本和任务的错误信息。"
};
export let structuredData = {
  "contents": [{
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥Why this error occurred"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "当在 单包工作区 中检测到 turbo 调用循环时，Turborepo 将抛出错误以防止对其自身的递归调用。通常，这种情况发生的原因有两个："
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥When a cycle of turbo invocations is detected in a single-package workspace, Turborepo will error to prevent the recursive calls to itself. Typically, this situation occurs for one of two reasons:"
  }, {
    "heading": "脚本和任务中的递归-recursion-in-scripts-and-tasks",
    "content": "¥Recursion in scripts and tasks"
  }, {
    "heading": "脚本和任务中的递归-recursion-in-scripts-and-tasks",
    "content": "在单软件包工作区中，package.json 中调用同名 Turborepo 任务的脚本会导致循环。"
  }, {
    "heading": "脚本和任务中的递归-recursion-in-scripts-and-tasks",
    "content": "¥In a single-package workspace, a script in package.json that calls a Turborepo task with the same name causes a loop."
  }, {
    "heading": "脚本和任务中的递归-recursion-in-scripts-and-tasks",
    "content": "调用 build 脚本会调用 turbo run build。然后，turbo run build 调用 build 脚本，启动递归调用循环。"
  }, {
    "heading": "脚本和任务中的递归-recursion-in-scripts-and-tasks",
    "content": "¥Calling the build script calls turbo run build. turbo run build then calls the build script, initiating the loop of recursive calls."
  }, {
    "heading": "脚本和任务中的递归-recursion-in-scripts-and-tasks",
    "content": "要解决此问题，请确保 package.json 中的脚本名称与 Turborepo 任务不同。例如，要修复上面的代码片段，重命名脚本可以打破循环："
  }, {
    "heading": "脚本和任务中的递归-recursion-in-scripts-and-tasks",
    "content": "¥To resolve this, ensure that the name of the script in package.json is not the same as the Turborepo task. For example, to fix the snippet above, renaming the script would break the cycle:"
  }, {
    "heading": "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
    "content": "¥Package manager Workspace misconfiguration"
  }, {
    "heading": "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
    "content": "配置错误的工作区可能会使 多软件包工作区 看起来像是一个单包工作区。这会导致 Turborepo 推断存储库的类型错误，从而将 package.json 中的脚本视为递归脚本。"
  }, {
    "heading": "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
    "content": "¥A misconfigured workspace can make it appear that a multi-package workspace is a single-package workspace. This causes Turborepo to infer that the repository is of the wrong type, causing it to see the script in package.json to be recursive."
  }, {
    "heading": "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
    "content": "你的代码库可以通过几种方式最终处于此状态，最常见的是 软件包未根据你的软件包管理器定义。如果 npm 工作区缺少 package.json 中的 workspaces 字段，或者 pnpm 工作区缺少 pnpm-workspace.yaml 文件，则会导致此错误消息。"
  }, {
    "heading": "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
    "content": "¥Your repo can end up in this state in a few ways, with the most common being that the packages are not defined according to your package manager. An npm workspace that is missing the workspaces field in package.json or a pnpm workspace that is missing a pnpm-workspace.yaml file can result in this error message."
  }, {
    "heading": "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
    "content": "检查你的代码库是否符合多包工作区的标准，并纠正任何问题。"
  }, {
    "heading": "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
    "content": "¥Check that your repository is complying with standards for multi-package workspaces and correct any issues."
  }],
  "headings": [{
    "id": "为什么会出现此错误-why-this-error-occurred",
    "content": "为什么会出现此错误 /*why-this-error-occurred*/"
  }, {
    "id": "脚本和任务中的递归-recursion-in-scripts-and-tasks",
    "content": "脚本和任务中的递归 /*recursion-in-scripts-and-tasks*/"
  }, {
    "id": "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
    "content": "软件包管理器工作区配置错误 /*package-manager-workspace-misconfiguration*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#为什么会出现此错误-why-this-error-occurred",
  title: _jsx(_Fragment, {
    children: "为什么会出现此错误 "
  })
}, {
  depth: 3,
  url: "#脚本和任务中的递归-recursion-in-scripts-and-tasks",
  title: _jsx(_Fragment, {
    children: "脚本和任务中的递归 "
  })
}, {
  depth: 3,
  url: "#软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
  title: _jsx(_Fragment, {
    children: "软件包管理器工作区配置错误 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "为什么会出现此错误-why-this-error-occurred",
      children: "为什么会出现此错误 "
    }), "\n", _jsx(_components.p, {
      children: "¥Why this error occurred"
    }), "\n", _jsxs(_components.p, {
      children: ["当在 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/guides/single-package-workspaces",
        children: "单包工作区"
      }), " 中检测到 ", _jsx(_components.code, {
        children: "turbo"
      }), " 调用循环时，Turborepo 将抛出错误以防止对其自身的递归调用。通常，这种情况发生的原因有两个："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When a cycle of ", _jsx(_components.code, {
        children: "turbo"
      }), " invocations is detected in a ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/guides/single-package-workspaces",
        children: "single-package workspace"
      }), ", Turborepo will error to prevent the recursive calls to itself. Typically, this situation occurs for one of two reasons:"]
    }), "\n", _jsx(_components.h3, {
      id: "脚本和任务中的递归-recursion-in-scripts-and-tasks",
      children: "脚本和任务中的递归 "
    }), "\n", _jsx(_components.p, {
      children: "¥Recursion in scripts and tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["在单软件包工作区中，", _jsx(_components.code, {
        children: "package.json"
      }), " 中调用同名 Turborepo 任务的脚本会导致循环。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In a single-package workspace, a script in ", _jsx(_components.code, {
        children: "package.json"
      }), " that calls a Turborepo task with the same name causes a loop."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["调用 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本会调用 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "。然后，", _jsx(_components.code, {
        children: "turbo run build"
      }), " 调用 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本，启动递归调用循环。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Calling the ", _jsx(_components.code, {
        children: "build"
      }), " script calls ", _jsx(_components.code, {
        children: "turbo run build"
      }), ". ", _jsx(_components.code, {
        children: "turbo run build"
      }), " then calls the ", _jsx(_components.code, {
        children: "build"
      }), " script, initiating the loop of recursive calls."]
    }), "\n", _jsxs(_components.p, {
      children: ["要解决此问题，请确保 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的脚本名称与 Turborepo 任务不同。例如，要修复上面的代码片段，重命名脚本可以打破循环："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To resolve this, ensure that the name of the script in ", _jsx(_components.code, {
        children: "package.json"
      }), " is not the same as the Turborepo task. For example, to fix the snippet above, renaming the script would break the cycle:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build:app\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "软件包管理器工作区配置错误-package-manager-workspace-misconfiguration",
      children: "软件包管理器工作区配置错误 "
    }), "\n", _jsx(_components.p, {
      children: "¥Package manager Workspace misconfiguration"
    }), "\n", _jsxs(_components.p, {
      children: ["配置错误的工作区可能会使 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#multi-package-workspace",
        children: "多软件包工作区"
      }), " 看起来像是一个单包工作区。这会导致 Turborepo 推断存储库的类型错误，从而将 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的脚本视为递归脚本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A misconfigured workspace can make it appear that a ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#multi-package-workspace",
        children: "multi-package workspace"
      }), " is a single-package workspace. This causes Turborepo to infer that the repository is of the wrong type, causing it to see the script in ", _jsx(_components.code, {
        children: "package.json"
      }), " to be recursive."]
    }), "\n", _jsxs(_components.p, {
      children: ["你的代码库可以通过几种方式最终处于此状态，最常见的是 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
        children: "软件包未根据你的软件包管理器定义"
      }), "。如果 npm 工作区缺少 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的 ", _jsx(_components.code, {
        children: "workspaces"
      }), " 字段，或者 pnpm 工作区缺少 ", _jsx(_components.code, {
        children: "pnpm-workspace.yaml"
      }), " 文件，则会导致此错误消息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Your repo can end up in this state in a few ways, with the most common being that the ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
        children: "packages are not defined according to your package manager"
      }), ". An npm workspace that is missing the ", _jsx(_components.code, {
        children: "workspaces"
      }), " field in ", _jsx(_components.code, {
        children: "package.json"
      }), " or a pnpm workspace that is missing a ", _jsx(_components.code, {
        children: "pnpm-workspace.yaml"
      }), " file can result in this error message."]
    }), "\n", _jsx(_components.p, {
      children: "检查你的代码库是否符合多包工作区的标准，并纠正任何问题。"
    }), "\n", _jsx(_components.p, {
      children: "¥Check that your repository is complying with standards for multi-package workspaces and correct any issues."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
